import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { getLanguageId } from 'utils/functions';

const initialState = {
  languageId: getLanguageId(),
  userLoginInfo: {
    identityType: false,
    identityNo: '',
    birthDate: '',
    rememberMe: false,
  },
  isSidebarOpen: false,
  isPageTitleVisible: true,
  videoCall: {
    isShow: false,
    isAccessGranted: false,
    isDoctorAttended: false,
    protocolNo: 0,
    videoCallGroupId: '',
    appointmentDate: '',
    patientName: '',
    doctorCode: '',
    doctorTitle: '',
    doctorName: '',
    doctorPhoto: '',
    screen: {
      isFullScreen: false,
      isDraggable: false,
      isCentred: false,
    },
  },
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setLanguageId: (state, action: PayloadAction<1 | 2>) => {
      state.languageId = action.payload;
    },
    setUserLoginInfo: (state, action: PayloadAction<typeof initialState.userLoginInfo>) => {
      state.userLoginInfo = action.payload;
    },
    resetUserLoginInfo: (state) => {
      state.userLoginInfo = initialState.userLoginInfo;
    },
    setSidebarOpen: (state, action: PayloadAction<boolean | 'toggle'>) => {
      action.payload === 'toggle'
        ? (state.isSidebarOpen = !state.isSidebarOpen)
        : (state.isSidebarOpen = action.payload);
    },
    setPageTitleVisible: (state, action: PayloadAction<boolean | 'toggle'>) => {
      action.payload === 'toggle'
        ? (state.isPageTitleVisible = !state.isPageTitleVisible)
        : (state.isPageTitleVisible = action.payload);
    },
    setVideoCall: (state, action: PayloadAction<typeof initialState.videoCall>) => {
      state.videoCall = action.payload;
    },
    resetVideoCall: (state) => {
      state.videoCall = initialState.videoCall;
    },
  },
});

export const {
  setLanguageId,
  setUserLoginInfo,
  resetUserLoginInfo,
  setSidebarOpen,
  setPageTitleVisible,
  setVideoCall,
  resetVideoCall,
} = appSlice.actions;

export default appSlice;
